/**
 * UTM & referrer attribution tracker.
 * Captures utm_* params + referrer on first page load, persists in sessionStorage.
 * Attribution follows the user across the funnel until form submission.
 */

const STORAGE_KEY = 'plexterra_attribution';
const UTM_KEYS = ['utm_source', 'utm_medium', 'utm_campaign', 'utm_term', 'utm_content'];

export const captureAttribution = () => {
  if (typeof window === 'undefined') return null;

  // Only capture once per session (first-touch attribution)
  const existing = sessionStorage.getItem(STORAGE_KEY);
  if (existing) {
    try {
      return JSON.parse(existing);
    } catch (e) {
      console.debug('[attribution] existing session payload was corrupt, recapturing:', e.name);
    }
  }

  const params = new URLSearchParams(window.location.search);
  const utms = {};
  UTM_KEYS.forEach(k => {
    const v = params.get(k);
    if (v) utms[k] = v.substring(0, 200);
  });

  const referrer = document.referrer && !document.referrer.startsWith(window.location.origin)
    ? document.referrer.substring(0, 500)
    : '';

  const landingPage = `${window.location.pathname}${window.location.search}`.substring(0, 500);

  const attribution = {
    ...utms,
    referrer,
    landing_page: landingPage,
    captured_at: new Date().toISOString()
  };

  // Only persist if we have meaningful data
  const hasData = Object.keys(utms).length > 0 || referrer;
  if (hasData) {
    try { sessionStorage.setItem(STORAGE_KEY, JSON.stringify(attribution)); } catch (e) { console.warn('[attribution] sessionStorage.setItem failed (quota or private mode):', e.name); }
  }

  return hasData ? attribution : null;
};

export const getAttribution = () => {
  if (typeof window === 'undefined') return null;
  try {
    const raw = sessionStorage.getItem(STORAGE_KEY);
    return raw ? JSON.parse(raw) : null;
  } catch (e) {
    return null;
  }
};
